/**
 * Created by razial on 18.09.2026.
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    DAILY_TASKS_TIMER_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    DAILY_TASK_REWARD_FONT: {
        size: 37,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    DAILY_TASK_FONT: {
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    DAILY_TASK_PROGRESS_FONT: {
        size: 32,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    DAILY_TASK_CTA: {
        size: 35,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.overrideStyles(cleverapps.styles.DailyTaskTimer, {
    offsetY: 3
});

cleverapps.overrideStyles(cleverapps.styles.DailyTasksWindow, {
    person: {
        x: { align: "center", dx: -960 },
        y: { align: "bottom", dy: -20 }
    },

    tabs: {
        x: { align: "left", dx: -155 }
    },

    window: {
        padding: {
            left: 15,
            right: 15,
            top: 40,
            bottom: 10
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DailyTasksTab, {
    scroll: {
        height: 680
    },

    timer: {
        padding: { x: 0, y: 15 }
    },

    foreground: {
        width: 868,
        wide: {
            width: 1178
        },
        height: 45,
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: 15 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DailyTasksCompleteAllView, {
    prize: {
        y: { align: "bottom", dy: -19 }
    },
    prizePosition: {
        x: { align: "right", dx: 50 },
        y: { align: "center", dy: 13 }
    },
    bar: {
        height: 44,
        progressFrames: {
            0: bundles.progress_bar.frames.bar_red,
            30: bundles.progress_bar.frames.bar_orange,
            70: bundles.progress_bar.frames.bar_green
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DailyTaskView, {
    icon: {
        bg: {
            wide: {
                width: 150
            },

            width: 150,
            height: 150
        }
    },

    titleAndRewards: {
        width: 300
    },

    progressBar: {
        height: 44,
        progressFrames: {
            0: bundles.progress_bar.frames.bar_red,
            30: bundles.progress_bar.frames.bar_orange,
            70: bundles.progress_bar.frames.bar_green
        }
    },

    button: {
        width: 230
    },

    reward: {
        textMargin: 5
    }
});
